<template>
	<section id="samhallet" class="w-100 bg-gray">
		<b-row v-view="viewHandler">
			<b-col cols="12" class="pt-lg-3 text-center viewer fade">
				<div class="px-3">
					<h3 class="pb-3 px-4 px-lg-0">
						<span class="d-block px-5 px-lg-0" v-if="$creo.getLang() == 'sv'">Värdeskapande i samhället</span>
						<span class="d-block px-5 px-lg-0" v-else>Value generation in society</span>
					</h3>
				</div>
			</b-col>
		</b-row>
		<b-row >
			<b-col cols="12" lg="10" xl="10" offset-lg="1" offset-xl="1" class="pt-lg-4 px-lg-5 heigt-vart">
				<b-row class="px-4 px-lg-5 " v-view="viewHandler">
					<b-col cols="6" lg="2" class="text-center pt-lg-5 px-2 px-lg-0 viewer fade delay-6" order="1" order-lg="1">
						<div>
							<b-img v-if="$creo.getLang() == 'sv'" src="../assets/img/vartext1.svg" class="img-text-one"/>
							<b-img v-else src="../assets/img/vartext2en.svg" class="img-text-one"/>
						</div>
					</b-col>
					<b-col cols="6" lg="2"  class="text-center pt-lg-5 px-2 px-lg-0 viewer fade delay-7" order="2"  order-lg="2">
						<div class="d-none d-lg-block">
							<b-img v-if="$creo.getLang() == 'sv'" src="../assets/img/vartext2.svg" class="img-text-two"/>
							<b-img v-else src="../assets/img/vartext1en.svg" class="img-text-two"/>
						</div>
						<div class="offset-img d-lg-none">
							<b-img v-if="$creo.getLang() == 'sv'" src="../assets/img/vartext2.svg" class="img-text-two"/>
							<b-img v-else src="../assets/img/vartext1en.svg" class="img-text-two"/>
						</div>
					</b-col>
					<b-col cols="6" lg="4" offset="3" offset-lg="0"  class="text-center pt-5 px-2 px-lg-0 viewer fade delay-8" order="5" order-lg="3">
						<div>
							<b-img v-if="$creo.getLang() == 'sv'" src="../assets/img/vartext3.svg" class="img-text-three"/>
							<b-img v-else src="../assets/img/vartext4en.svg" class="img-text-three"/>
						</div>
					</b-col>
					<b-col cols="6" lg="2"  class="text-center pt-5 px-2 px-lg-0 viewer fade delay-9" order="7" order-lg="4">
						<div class="d-none d-lg-block">
							<b-img v-if="$creo.getLang() == 'sv'" src="../assets/img/vartext3ny.svg" class="img-text-four"/>
							<b-img v-else src="../assets/img/vartext3nyen.svg" class="img-text-four"/>
						</div>
						<div class=" d-lg-none">
							<b-img v-if="$creo.getLang() == 'sv'" src="../assets/img/vartext4.svg" class="img-text-four"/>
							<b-img v-else src="../assets/img/vartext3en.svg" class="img-text-four"/>
						</div>
					</b-col>
					<b-col cols="6" lg="2"  class="text-center pt-5 px-2 px-lg-0 viewer fade delay-10" order="8" order-lg="5">
						<div>
							<b-img v-if="$creo.getLang() == 'sv'" src="../assets/img/vartext5.svg" class="img-text-five special"/>
							<b-img v-else src="../assets/img/vartext5en.svg" class="img-text-five special"/>
						</div>
					</b-col>

					<b-col cols="6" lg="2"  class="text-center px-3 px-2 px-lg-0 viewer fade"  order="3" order-lg="6">
						<div class="px-1 px-lg-0">
							<b-img src="../assets/img/vard1.png" class="img-samhallet special"/>
						</div>
						<p class="m-0 pt-3 small d-lg-none">
							<span v-if="$creo.getLang() == 'sv'">Förvärv</span>
							<span v-else>Acquisition</span>

						</p>
					</b-col>
					<b-col cols="6" lg="2"  class="text-center px-3 px-lg-0 viewer fade delay-1"  order="4" order-lg="7">
						<div class="px-1 px-lg-0">
							<b-img src="../assets/img/vard2.png" class="img-samhallet special"/>
						</div>
						<p class="m-0 pt-3 small d-lg-none">
							<span v-if="$creo.getLang() == 'sv'">Planering</span>
							<span v-else>Planning</span>

						</p>
					</b-col>
					<b-col cols="6" lg="2"  class="text-center px-0 viewer fade delay-2"   order="5" order-lg="8">
						<div class="h-100 w-100 position-relative d-none d-lg-block">
							<b-img src="../assets/img/vard3.png" class="img-samhallet bygg position-absolute"/>
						</div>
						<div class="d-lg-none">
							<b-img src="../assets/img/vard3.png" class="img-samhallet bygg"/>
						</div>
						<p class="m-0 pt-3 small d-lg-none">
							<span v-if="$creo.getLang() == 'sv'">Byggarbetsplats</span>
							<span v-else>Construction site</span>

						</p>
					</b-col>
					<b-col cols="6" lg="2"  class="text-center px-3 px-lg-0 viewer fade delay-3"   order="6" order-lg="9">
						<div class="px-1 px-lg-0">
							<b-img src="../assets/img/vard4.png" class="img-samhallet"/>
						</div>
						<p class="m-0 pt-4 pt-lg-3 small d-lg-none">
							<span v-if="$creo.getLang() == 'sv'">Färdig byggnad</span>
							<span v-else>Completed construction</span>

						</p>
					</b-col>
					<b-col cols="6" lg="2"  class="text-center px-3 px-lg-0 viewer fade delay-4"   order="9" order-lg="10">
						<div class="px-1 px-lg-0">
							<b-img src="../assets/img/vard5.png" class="img-samhallet"/>
						</div>
						<p class="m-0 pt-3 small d-lg-none">
							<span v-if="$creo.getLang() == 'sv'">Förvaltning</span>
							<span v-else>Management</span>

						</p>
					</b-col>
					<b-col cols="6" lg="2"  class="text-center px-3 px-lg-0 viewer fade delay-5"  order="10" order-lg="11">
						<div class="px-1 px-lg-0">
							<b-img src="../assets/img/vard6.png" class="img-samhallet"/>
						</div>
						<p class="m-0 pt-3 small d-lg-none">
							<span v-if="$creo.getLang() == 'sv'">Framtida återvinning eller demontering</span>
							<span v-else>Future recycling or dismantling</span>

						</p>
					</b-col>
				</b-row>

				<b-row class="d-lg-none pt-4">
					<b-col cols="12" class="text-center">
						<a 	:href="$creo.browserPdfLink(pdfLink.org[$creo.getLang()], pdfLink.fallback[$creo.getLang()], pdfLink.page[$creo.getLang()])"
							target="_blank"
							class="btn btn-link pt-3 italic black text-decoration-none standard-white">
							<span v-if="$creo.getLang() == 'sv'">Läs mer</span>
							<span v-else>Read more</span><span class="ml-2 arrow-gray black float-right"></span>
						</a>
					</b-col>
				</b-row>

					<b-row class="px-5 d-none d-lg-flex" v-view="viewHandler">

					<b-col cols="6" lg="2"  class="text-center pt-4 pt-lg-1 px-0 viewer fade" >
						<p class="m-0 pt-3 small">
							<span v-if="$creo.getLang() == 'sv'">Förvärv</span>
							<span v-else>Acquisition</span>

						</p>
					</b-col>
					<b-col cols="6" lg="2"  class="text-center pt-4 pt-lg-1 px-0 viewer fade delay-1"  >
						<p class="m-0 pt-3 small">
							<span v-if="$creo.getLang() == 'sv'">Planering</span>
							<span v-else>Planning</span>

						</p>
					</b-col>
					<b-col cols="6" lg="2"  class="text-center pt-4 pt-lg-1 px-0 viewer fade delay-2" >
						<p class="m-0 pt-3 small">
							<span v-if="$creo.getLang() == 'sv'">Byggarbetsplats</span>
							<span v-else>Construction site</span>

						</p>
					</b-col>
					<b-col cols="6" lg="2"  class="text-center pt-4 pt-lg-1 px-0 viewer fade delay-3">
						<p class="m-0 pt-3 small">
							<span v-if="$creo.getLang() == 'sv'">Färdig byggnad</span>
							<span v-else>Completed construction</span>

						</p>
					</b-col>
					<b-col cols="6" lg="2"  class="text-center pt-4 pt-lg-1 px-0 viewer fade delay-4">
						<p class="m-0 pt-3 small">
							<span v-if="$creo.getLang() == 'sv'">Förvaltning</span>
							<span v-else>Management</span>

						</p>
					</b-col>
					<b-col cols="6" lg="2"  class="text-center pt-4 pt-lg-1 px-0 viewer fade delay-5">
						<p class="m-0 pt-3 small">
							<span v-if="$creo.getLang() == 'sv'">Framtida återvinning eller demontering</span>
							<span v-else>Future recycling or dismantling</span>

						</p>
					</b-col>
					<b-col cols="12" class="text-center viewer fade">
						<a 	:href="$creo.browserPdfLink(pdfLink.org[$creo.getLang()], pdfLink.fallback[$creo.getLang()], pdfLink.page[$creo.getLang()])"
							target="_blank"
							class="btn btn-link pt-3 italic black text-decoration-none standard-white">
							<span v-if="$creo.getLang() == 'sv'">Läs mer</span>
							<span v-else>Read more</span><span class="ml-2 arrow-gray black float-right"></span>
						</a>
					</b-col>
				</b-row>
			</b-col>
		</b-row>
	</section>
</template>
<script>
	import CModal from '@/components/Modal.vue'
	export default {
		props: {
			pdfLink: Object
		},
		data() {
			return {
				openId: 0
			}
		},
		components: {
			CModal
		},
		methods: {
			viewHandler(e) {
				// console.log(e)
			}
		}
	}
</script>
